import apiTrainingGroups from '@/api/training-groups'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  trainingGroup: null
}

export const mutationTypes = {
  updateTrainingGroupStart:
    '[update training group] Update training group start',
  updateTrainingGroupSuccess:
    '[update training group] Update training group success',
  updateTrainingGroupFailure:
    '[update training group] Update training group failure',

  getTrainingGroupStart: '[update training group] Get training group start',
  getTrainingGroupSuccess: '[update training group] Get training group success',
  getTrainingGroupFailure: '[update training group] Get training group failure'
}

export const actionTypes = {
  updateTrainingGroup: '[update training group] Update training group',
  getTrainingGroup: '[update training group] Get training group'
}

const mutations = {
  [mutationTypes.updateTrainingGroupStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateTrainingGroupSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateTrainingGroupFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getTrainingGroupStart](state) {
    state.isLoading = true
    state.trainingGroup = null
  },

  [mutationTypes.getTrainingGroupSuccess](state, payload) {
    state.trainingGroup = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupFailure](state, payload) {
    state.error = payload
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateTrainingGroup](context, {id, trainingGroupInput}) {
    context.commit(mutationTypes.updateTrainingGroupStart)
    return new Promise(resolve => {
      apiTrainingGroups
        .updateTrainingGroup(id, trainingGroupInput)
        .then(response => {
          context.commit(mutationTypes.updateTrainingGroupSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateTrainingGroupFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getTrainingGroup](context, {id}) {
    context.commit(mutationTypes.getTrainingGroupStart)
    return new Promise(resolve => {
      apiTrainingGroups
        .getTrainingGroup(id)
        .then(response => {
          context.commit(mutationTypes.getTrainingGroupSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingGroupFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
